const request = {
    invalid_input: "L'entrée est invalide. {{details}}",
    general: "Une erreur de requête s'est produite.",
};
export default request;
